module.exports = __webpack_public_path__ + "static/img/头像10.78537bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像10.png
// module id = jTwM
// module chunks = 1